import { createContext, type PropsWithChildren } from 'react';

import { CONSTANTS } from '../../constants';
import {
  type ConstantsType,
  useConstantsProviderHook,
  useRefreshTokens
} from 'utils/hooks';

export const ConstantsContext = createContext<ConstantsType>(CONSTANTS);

export const ConstantsProvider = ({ children }: PropsWithChildren<any>) => {
  const { CONSTANTS } = useConstantsProviderHook();
  return (
    <ConstantsContext.Provider value={CONSTANTS}>
      {children}
    </ConstantsContext.Provider>
  );
};
